(function () {
  /* sv-xsell-v2 (2026-09-23): produkt uzupełniający oglądany wcześniej (localStorage sv_recent, za zgodą na preferencje) idzie na początek listy
     z plakietką „Oglądane”; widoczne tylko pierwsze data-xsell-max kart. */
  function svXsellRerank(root) {
    var list = root && root.querySelector('.cart-drawer-upsell-list[data-xsell-smart]')
    if (!list) return
    var recent = []
    try {
      /* tylko za zgodą na pliki preferencji (Customer Privacy API Shopify); bez zgody zwykła kolejność */
      var cp = window.Shopify && window.Shopify.customerPrivacy
      if (!cp || typeof cp.preferencesProcessingAllowed !== 'function' || !cp.preferencesProcessingAllowed()) throw 0
      recent = JSON.parse(localStorage.getItem('sv_recent') || '[]').map(function (r) {
        return String(r && r.id)
      })
    } catch (e) {}
    var items = Array.prototype.slice.call(list.children)
    var viewed = items.filter(function (li) {
      return li.dataset.xsellSource === 'complement' && recent.indexOf(li.dataset.productId) > -1
    })
    viewed.sort(function (a, b) {
      return recent.indexOf(a.dataset.productId) - recent.indexOf(b.dataset.productId)
    })
    viewed.forEach(function (li) {
      list.insertBefore(li, list.firstElementChild)
      if (li.dataset.xsellBadge !== 'same_color') {
        var badge = li.querySelector('[data-xsell-badge-label]')
        if (badge && list.dataset.xsellViewedLabel) {
          badge.textContent = list.dataset.xsellViewedLabel
          badge.hidden = false
          li.dataset.xsellBadge = 'viewed'
        }
      }
    })
    var max = parseInt(list.dataset.xsellMax, 10) || 2
    Array.prototype.slice.call(list.children).forEach(function (li, i) {
      li.hidden = i >= max
    })
  }
  window.svXsellRerank = svXsellRerank

  /* perf 30.09 D-02/B-12: lista „Dopełnij zestaw” przychodzi jako <template id="cart-drawer-upsell-template"> wewnątrz
     cart-drawer-items (snippets/cart-drawer.liquid, tylko przy niepustym koszyku). Każde przerysowanie szuflady (dodanie,
     zmiana ilości, prezent Pony) przynosi świeży szablon w tej samej odpowiedzi, więc nie pobieramy już sekcji szuflady osobnym
     zapytaniem. lastTplHtml = szablon, z którego jest obecna kopia: ten sam szablon = kopia zostaje (z wybranym kolorem);
     lastTplEmpty = ten szablon nie miał kart (nie wstawiamy go w kółko). */
  var lastTplHtml
  var lastTplEmpty = false
  var jdgmPending = false

  function upsellTemplateHtml(cartDrawerItems) {
    var tpl = cartDrawerItems.querySelector('template#cart-drawer-upsell-template')
    if (!tpl) {
      /* perf 30.09 R1-03: zgodność w oknie wgrywania (nowy skrypt, strona ze starym HTML szuflady bez <template>): lista
         z ukrytego #cart-drawer-upsell-wrapper, jak w LIVE, ale bez pobierania sekcji. Nowy HTML ma ten wrapper tylko
         w treści <template> (poza DOM), więc tam ta gałąź zwraca null. */
      var old = document.querySelector('#cart-drawer-upsell-wrapper')
      return old ? old.innerHTML : null
    }
    var inner = tpl.content && tpl.content.querySelector('#cart-drawer-upsell-wrapper')
    return inner ? inner.innerHTML : null
  }

  /* perf 30.09 B-12: gwiazdki Judge.me po narysowaniu klatki (requestAnimationFrame + setTimeout 0), nie w zadaniu wstawiania
     listy - w labie ta funkcja wymuszała przeliczenie układu w tym samym zadaniu, gdy klientka chciała już dotknąć kasy */
  function recallJudgeMeBadges() {
    if (!window.jdgm || !jdgm.allBadgesRecall || jdgmPending) return
    jdgmPending = true
    requestAnimationFrame(function () {
      setTimeout(function () {
        jdgmPending = false
        try {
          jdgm.allBadgesRecall()
        } catch (e) {}
      }, 0)
    })
  }

  /* T8 (02.10, CEO): przełącznik torby (slot [data-sv-torba-slot] z cart-drawer.liquid) zawsze jako ostatni element przewijanej
     części szuflady - pod kopią „Dopełnij zestaw”, a gdy jej nie ma, pod pozycjami. Wołane po każdym wstawieniu kopii (obserwator
     przerysowań niżej), więc kolejność wraca na miejsce w tym samym mikrozadaniu co przerysowanie, przed rysowaniem klatki.
     Pusty slot (koszyk z samymi produktami no_gift_wrapping) zostaje w stopce bez wysokości. */
  function placeTorbaSlot() {
    var wrapper = document.querySelector('#CartDrawer .cart-drawer-items-wrapper')
    var slot = document.querySelector('#CartDrawer [data-sv-torba-slot]')
    if (!wrapper || !slot || !slot.querySelector('.cart-upsell-toggle-container')) return
    if (wrapper.lastElementChild === slot) return
    wrapper.appendChild(slot)
  }

  function insertSectionCartDrawer() {
    insertUpsellCopy()
    placeTorbaSlot()
  }

  function insertUpsellCopy() {
    var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
    if (!cartDrawerItems) return

    if (cartDrawerItems.classList.contains('is-empty')) return

    var wrapper = document.querySelector('#CartDrawer .cart-drawer-items-wrapper')
    if (!wrapper) {
      wrapper = document.createElement('div')
      wrapper.classList.add('cart-drawer-items-wrapper')
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
      wrapper.appendChild(cartDrawerItems)
    }

    var existingUpsellInWrapper = wrapper.querySelector('#cart-drawer-upsell')
    var html = upsellTemplateHtml(cartDrawerItems)
    /* kopia z tego samego szablonu już stoi (albo ten szablon nie ma kart) = nic do zrobienia */
    if (html === lastTplHtml && (existingUpsellInWrapper || lastTplEmpty)) return

    // Remove any previously-inserted upsell block from the wrapper so we can
    // re-insert a fresh copy from the new template.
    if (existingUpsellInWrapper) existingUpsellInWrapper.remove()
    lastTplHtml = html
    lastTplEmpty = true
    if (html === null) return

    wrapper.insertAdjacentHTML('beforeend', html)

    // If no upsell items were rendered, remove the empty block we just inserted.
    const insertedUpsell = wrapper.querySelector('#cart-drawer-upsell')
    if (insertedUpsell && !insertedUpsell.querySelector('.cart-drawer-upsell-list li')) {
      insertedUpsell.remove()
    }
    if (insertedUpsell && insertedUpsell.isConnected) lastTplEmpty = false
    /* sv-xsell-v3: kopia sekcji ma te same id co ukryty szablon; unikalne id kółek, żeby etykieta przełączała kółko w widocznej kopii */
    if (insertedUpsell && insertedUpsell.isConnected) {
      insertedUpsell.querySelectorAll('input[id^="XsSw-"]').forEach(function (inp) {
        var old = inp.id
        inp.id = old + '-d'
        var lab = insertedUpsell.querySelector('label[for="' + old + '"]')
        if (lab) lab.htmlFor = inp.id
      })
    }
    if (insertedUpsell && insertedUpsell.isConnected) svXsellRerank(insertedUpsell)
    // Re-initialize Judge.me badges on newly inserted elements
    if (insertedUpsell && insertedUpsell.isConnected) recallJudgeMeBadges()
  }
  insertSectionCartDrawer()

  /* perf 30.09 R1-04: kolejność „Oglądane” wymaga API zgód (Shopify.customerPrivacy), które często jest gotowe dopiero po
     wstawieniu kopii przy wejściu. LIVE układał listę drugi raz przy pierwszym otwarciu szuflady (po pobraniu sekcji); tu
     układamy istniejącą kopię ponownie, gdy API zgód jest gotowe, i przy każdym otwarciu szuflady. svXsellRerank jest
     idempotentna (ten sam wynik przy kolejnym wywołaniu), a przestawienie kart obserwator pomija (zmiany w #cart-drawer-upsell). */
  function rerankInsertedUpsell() {
    var copy = document.querySelector('#CartDrawer .cart-drawer-items-wrapper #cart-drawer-upsell')
    if (copy) svXsellRerank(copy)
  }
  document.addEventListener('cart:open', rerankInsertedUpsell)
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (!err) rerankInsertedUpsell()
    })
  }

/*  async function insertSectionCartPage() {
    const cartItems = document.querySelector('cart-items')
    if (!cartItems) return

    const existingUpsells = document.querySelector('#MainContent #cart-drawer-upsell')
    if (existingUpsells) {
      existingUpsells.remove()
    }

    const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
    cartItems.querySelector('.page-width').insertAdjacentHTML('beforeend', upsells.innerHTML)

    if (!document.querySelector('.cart-drawer-upsell-list li')) {
      document.querySelector('#cart-drawer-upsell').remove()
    }
  }
  insertSectionCartPage() */

  window.onChangeKsUpsellVariantSelector = function( select, event) {
    event.preventDefault()
    const opt = select.options[select.selectedIndex]
    const imgSrc = opt.dataset.variantImg
    const card = select.closest('.cart-drawer-upsell-list-item')

    if (imgSrc) {
      const img = card.querySelector('.cart-drawer-upsell-list-item-left img')
      img.src = imgSrc
    }
    const promo = card && card.querySelector('[data-xsell-promo]')
    if (promo) {
      const pct = opt.dataset.pct
      promo.textContent = pct ? '−' + pct + '%' : ''
      promo.hidden = !pct
    }
    const priceLine = card && card.querySelector('[data-xsell-price]')
    if (priceLine) {
      /* jak przy zmianie koloru: wiersz ceny zawsze widoczny, przekreślenie tylko w promocji */
      const compare = opt.dataset.compare
      priceLine.classList.toggle('is-sale', !!compare)
      const s = priceLine.querySelector('[data-xsell-compare]')
      if (s) {
        s.hidden = !compare
        s.textContent = compare || ''
      }
      const lab = priceLine.querySelector('[data-xsell-compare-label]')
      if (lab) lab.hidden = !compare
      const cur = priceLine.querySelector('[data-xsell-current]')
      if (cur) cur.textContent = opt.dataset.price || ''
    }
  }

  function listenCartDrawer() {
    const element = document.querySelector('cart-drawer')
    if (!element) return

    /* perf 30.09 B-12 (+ H1): reagujemy tylko na przerysowanie zawartości (childList) poza kartami i gwiazdkami, a listę bierzemy
       z szablonu, który przyszedł z tym przerysowaniem - bez pobierania sekcji. Samo otwarcie/zamknięcie (klasy active/animate),
       zapisy Langify na EU (data-ly-processed, src) i przepisywanie gwiazdek Judge.me nie zmieniają koszyka; wcześniej każde
       z nich po 250 ms pobierało /cart?section_id=cart-drawer i podmieniało listę. Wstawienie kopii jest idempotentne
       (ten sam szablon + kopia na miejscu = nic), więc obserwator nie zapętla się na własnych zmianach. */
    const observer = new MutationObserver((mutations) => {
      var relevant = mutations.some(function (m) {
        /* zmiany w środku karty (wybór koloru, plakietki, gwiazdki) nie są przerysowaniem szuflady */
        return m.type === 'childList' && !(m.target.closest && m.target.closest('.jdgm-prev-badge, .jdgm-widget, .sv-xs-card, #cart-drawer-upsell'))
      })
      if (relevant) insertSectionCartDrawer()
    })

    observer.observe(element, {
      childList: true,
      subtree: true
    });
  }
  /* sv-xsell-v3 (2026-09-26): wybór koloru kółkiem w karcie „Dopełnij zestaw”: wariant do formularza, zdjęcie, nazwa koloru,
     cena, plakietka promocji, plakietka „Ten sam kolor” / „Do kompletu” (prawdziwa tylko dla koloru z koszyka), opis przycisku */
  document.addEventListener('change', function (e) {
    var r = e.target
    if (!r || !r.matches || !r.matches('.sv-xs-card input[data-xs-variant]')) return
    var card = r.closest('.sv-xs-card')
    var id = card.querySelector('input[data-xsell-id]')
    if (id) id.value = r.value
    var img = card.querySelector('img[data-xsell-img]')
    if (img && r.dataset.img) img.src = r.dataset.img
    card.querySelectorAll('[data-xs-name]').forEach(function (s) {
      s.classList.toggle('is-on', s.dataset.xsName === r.dataset.i)
    })
    var pct = r.dataset.pct
    var promo = card.querySelector('[data-xsell-promo]')
    if (promo) {
      promo.textContent = pct ? '−' + pct + '%' : ''
      promo.hidden = !pct
    }
    var price = card.querySelector('[data-xsell-price]')
    if (price) {
      var compare = r.dataset.compare
      price.classList.toggle('is-sale', !!compare)
      var s = price.querySelector('[data-xsell-compare]')
      if (s) {
        s.hidden = !compare
        s.textContent = compare || ''
      }
      var lab = price.querySelector('[data-xsell-compare-label]')
      if (lab) lab.hidden = !compare
      var cur = price.querySelector('[data-xsell-current]')
      if (cur) cur.textContent = r.dataset.price || ''
    }
    var kind = card.dataset.xsellBadge
    if (kind === 'same_color' || kind === 'complement') {
      var match = card.dataset.xsellMatch
      var same = !!match && match !== 'none' && r.dataset.value === match
      var badge = card.querySelector('[data-xsell-badge-label]')
      if (badge) badge.textContent = same ? card.dataset.labelSame : card.dataset.labelComplement
      card.dataset.xsellBadge = same ? 'same_color' : 'complement'
    }
    var btn = card.querySelector('button.xs-add')
    if (btn && btn.dataset.xsAria) btn.setAttribute('aria-label', btn.dataset.xsAria + ', ' + r.dataset.value)
    /* link do wybranego wariantu; przedsprzedaż = link na stronę wariantu zamiast dodania bez planu */
    if (r.dataset.url) {
      card.querySelectorAll('[data-xsell-link], [data-xsell-pre]').forEach(function (a) {
        a.href = r.dataset.url
      })
    }
    var pre = card.querySelector('[data-xsell-pre]')
    var isPre = r.dataset.pre === '1'
    if (pre) pre.hidden = !isPre
    if (btn) btn.hidden = isPre
  })

  listenCartDrawer()

  /* listenCartPage() removed — insertSectionCartPage() is commented out,
     calling it caused ReferenceError crash on /cart page. */
})();
